export const getPositiveIntegerValueOrDefault = (
    search: string,
    param: string,
    defaultValue: number,
) => {
    const value = parseInt(getValue(search, param));
    return value !== null && value > 0 ? value : defaultValue;
};

export const getIntegerValueInOrDefault = (
    search: string,
    param: string,
    defaultValue: number,
    validValues: number[],
) => {
    const value = parseInt(getValue(search, param));
    return value !== null && validValues.includes(value) ? value : defaultValue;
};

export const getValueOrDefault = (search: string, param: string, defaultValue: string) => {
    const value = getValue(search, param);
    return value !== null ? value : defaultValue;
};

const getValue = (search: string, param: string) => {
    const urlParams = new URLSearchParams(search);
    const params = urlParams.get(param);
    return params !== null ? params : '';
};

export const prepareSearch = (searchParam: Map<string, string>) => {
    const search: string[] = [];
    searchParam.forEach((value, key) => {
        if (value) {
            search.push(`${key}=${value}`);
        }
    });
    return search.length === 0 ? '' : search.join('&');
};

export const updateSearch = (search: string, param: string, value: string) => {
    const searchParam = new URLSearchParams(search);
    searchParam.set(param, value);
    return searchParam.toString();
};
